import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.11031 11.389C5.89552 11.1742 5.89552 10.8259 6.11031 10.6111L8.7214 8.00005L6.11031 5.38896C5.89552 5.17417 5.89552 4.82593 6.11031 4.61114C6.3251 4.39635 6.67334 4.39635 6.88813 4.61114L9.88813 7.61114C10.1029 7.82593 10.1029 8.17417 9.88813 8.38896L6.88813 11.389C6.67334 11.6037 6.3251 11.6037 6.11031 11.389Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }